import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveElementConstraintsRequestFailure(elementId) {
      const req = getState().find((req) => req.elementId === elementId);

      return req ? req.request.isFailure : false;
    },
    isRetrieveElementConstraintsRequestPending(elementId) {
      const req = getState().find((req) => req.elementId === elementId);

      return req ? req.request.isPending : false;
    },
    isRetrieveElementConstraintsRequestSuccess(elementId) {
      const req = getState().find((req) => req.elementId === elementId);

      return req ? req.request.isSuccessful : false;
    },
    getElementConstraints(elementId) {
      const req = getState().find((req) => req.elementId === elementId);

      return req ? req.constraints : [];
    },
  };
}

export { createSelector };
